import {
  Menu,
  Button,
  MenuButton,
  MenuList,
  MenuDivider,
  MenuItem,
  MenuOptionGroup,
  MenuItemOption,
  Textarea,
  Progress,
  Select,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Input,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  CloseButton,
} from "@chakra-ui/react";
import React, { useState } from 'react';
import { ChevronDownIcon, ArrowForwardIcon } from "@chakra-ui/icons";

import styles from "./CompositeTextArea.module.css";


const CompositeTextArea = ({
    messageId,
    username,
    message,
    menuColorScheme=null,
    userSet,
    addUser,
    updateMessageUser,
    setConversation
  }) => {

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [newUsername, setNewUsername] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const initialRef = React.useRef(null)
  // const finalRef = React.useRef(null)

  const handleUsernameInputChange = (e) => {
    setNewUsername(e.target.value)
  }

  const addUserShim = () => {
    if(newUsername==''){
      setErrorMessage("Empty user name");
      setShowErrorMessage(true);
      setTimeout(()=>{
        setShowErrorMessage(false);
      }, 5000)
      console.log("Empty user name");
    }
    else if(userSet.has(newUsername)){
      setErrorMessage(`User with name ${newUsername} already exists!`);
      setShowErrorMessage(true);
      setTimeout(()=>{
        setShowErrorMessage(false);
      }, 5000);
      console.log(`User with name ${newUsername} already exists!`);
    }
    else {
      addUser(newUsername);
      setSuccessMessage(`New user ${newUsername} added successfully!`);
      setShowSuccessMessage(true);
      setTimeout(()=>{
        setSuccessMessage(false);
      }, 5000)
      console.log(`New user ${newUsername} added successfully!`)
    }
  }

  const handleInputChange = (e, messageId) => {
    let inputValue = e.target.value;
    setConversation(prevState => ({...prevState, [messageId]: {...prevState[messageId], message: inputValue}}));
  }



  return (
    <div className={styles.dropdowndefaultParent}>
      <Menu closeOnSelect={false}>
        <MenuButton
          as={Button}
          rightIcon={<ChevronDownIcon />}
          colorScheme="blue"
          variant="outline"
          size="sm"
        >
          { username }
        </MenuButton>
        <MenuList>
          <MenuOptionGroup
            onChange={value => updateMessageUser(messageId, value)}
            defaultValue={username}
            title='Select User'
            type='radio'>
           {
            [...userSet].map((username)=>(
              <MenuItemOption
                key={username}
                value={username}>
                  {username}
              </MenuItemOption>

            ))
          }
          </MenuOptionGroup>
          <MenuDivider />
          <MenuItem onClick={onOpen} value="Add user">Add user</MenuItem>
        </MenuList>
      </Menu>
      <Textarea
        className={styles.textAreaflushed}
        variant="flushed"
        placeholder="Enter Message"
        backgroundColor="gray.50"
        value={message}
        onChange={(value)=>handleInputChange(value, messageId)}
      />

    <Modal
      initialFocusRef={initialRef}
      // finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add user</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <FormControl isInvalid={showErrorMessage}>
            <FormLabel>Username</FormLabel>
            <Input onChange={handleUsernameInputChange} ref={initialRef} placeholder='Enter name of user' />
             {showSuccessMessage ? (
               <FormHelperText>{successMessage}</FormHelperText>
               ) : ''}

             {showErrorMessage ? (
               <FormErrorMessage>{errorMessage}</FormErrorMessage>
               ) : ''}

          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button onClick={addUserShim} colorScheme='blue' mr={3}>
            Save
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>


    </div>
  );

};

export default CompositeTextArea;